import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class GroupManagersProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(groupId: string): Promise<GroupManagerSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/groups/' + groupId + '/managers';
        return await this.http.get<GroupManagerSummaryDTO[]>(url).toPromise();
    }

    async create(groupId: string, dto: CreateGroupManagerDTO): Promise<void> {
        const url = this.configurationService.APIURL + '/api/groups/' + groupId + '/managers';
        await this.http.post<void>(url, dto).toPromise();
    }

    async delete(groupId: string, email: string): Promise<void> {
        const url = this.configurationService.APIURL + '/api/groups/' + groupId + '/managers';
        const params = new HttpParams().set('email', email);
        await this.http.delete<void>(url, { params }).toPromise();
    }

    async resetPassword(groupId: string, email: string): Promise<void> {
        const url = this.configurationService.APIURL + '/api/groups/' + groupId + '/managers/resetPassword';
        const params = new HttpParams().set('email', email);
        await this.http.post<void>(url, {}, { params }).toPromise();
    }
}

export interface GroupManagerSummaryDTO {
    firstName: string;
    lastName: string;
    email: string;
    lastLogin: Date | string | null;
}

export interface CreateGroupManagerDTO {
    firstName: string;
    lastName: string;
    email: string;
}
